// extracted by mini-css-extract-plugin
export default {"buttonText":"ButtonPartner_buttonText__0z96X","button":"ButtonPartner_button__4M68y","click":"ButtonPartner_click__wj4NP","animate":"ButtonPartner_animate__HGbsV"};